
import React, { useState, useEffect, memo, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import fpc_logo from '../../styles/assets/icons/FPC/FP-Logo_Favicon.png'
import { useSelector, useDispatch } from 'react-redux';
import { fetchUserData } from '../../redux/userActions.js';
import Avatar from '../../pages/avatar/RandomAvatar';
import SvgComponent from '../../styles/assets/icons/FPC/SvgComponent';

const Sidebar = ({ isCollapsed = false, onCollapse }) => {
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state.user);

  useEffect(() => {
    if (!userDetails) {
      dispatch(fetchUserData());
    }
  }, [dispatch]);

  const getRole = (roleNum) => {
    switch (Number(roleNum)) {
      case 0:
        return "SUPER_ADMIN";
      case 1:
        return "ADMIN";
      case 2:
        return "PARTNER";
      case 3:
        return "TEAM_LEAD";
      default:
        return "TEAM_LEAD";
    }
  };

  const role = getRole(userDetails?.role);
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);

  const navigationItems = [

    {
      label: 'Dashboard',
      path: '/app/dashboard',
      icon: 'LayoutDashboard',
      tooltip: 'Dashboard',
      role: ['TEAM_LEAD', 'PARTNER', 'ADMIN', 'SUPER ADMIN']
    },

    {
      label: 'Client Estimates',
      path: '/app/client-estimates',
      icon: 'ClipboardList',
      tooltip: 'Show Client Estimates',
      role: ['TEAM_LEAD', 'PARTNER', 'ADMIN', 'SUPER ADMIN']
    },
    {
      label: 'Users',
      path: '/app/admin',
      icon: 'Users',
      tooltip: 'Show users',
      role: ['ADMIN', 'SUPER ADMIN']
    }
  ];

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location?.pathname]);

  const handleNavigation = (path, state = {}) => {
    navigate(path, { state });
  };

  const handleMobileToggle = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  const handleBackdropClick = () => {
    setIsMobileOpen(false);
  };

  const isActive = (path) => {
    return location?.pathname === path;
  };


  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const profileRef = useRef(null);
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setIsProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsProfileOpen(false);
      }
    };

    const handleEsc = (event) => {
      if (event.key === "Escape") {
        setIsProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);

  const handleLogout = () => {
    // dispatch(logout()) if using redux
    navigate("/auth");
  };

  const filteredNavItems = navigationItems.filter((item) =>
    item.role.includes(role)
  );

  return (
    <>
      <button
        className="mobile-nav-toggle"
        onClick={handleMobileToggle}
        aria-label="Toggle navigation menu"
        aria-expanded={isMobileOpen}
      >
        <Icon name={isMobileOpen ? 'X' : 'Menu'} size={24} />
      </button>
      {isMobileOpen && (
        <div
          className="fixed inset-0 bg-black/40 backdrop-blur-sm z-30 lg:hidden"
          onClick={handleBackdropClick}
          aria-hidden="true"
        />
      )}
      <aside
        className={`
    fixed 
    top-0 
    left-0 
    h-full 
    w-72 
    bg-card 
    text-card-foreground 
    shadow-xl 
    transform 
    transition-transform 
    duration-300 
    z-30 
    ${isMobileOpen ? 'translate-x-0' : '-translate-x-full'}
    lg:hidden
  `}
      >
        <div className="sidebar-header">
          <div className="sidebar-logo">
            {/* <Icon name="Factory" size={24} color="var(--color-primary-foreground)" /> */}
            <img src={fpc_logo} />
          </div>
          <span className="sidebar-logo-text">Budget Estimator</span>
          {/* <button
            onClick={() => setIsMobileOpen(false)}
            className="
      p-2 
      rounded-md 
      hover:bg-muted 
      transition-colors
    "
            aria-label="Close sidebar"
          >
            <Icon name="X" size={20} />
          </button> */}
        </div>

        {/* <nav className="sidebar-nav"> */}
        <nav className="sidebar-nav overflow-y-auto flex-1">
          {filteredNavItems?.map((item) => {
            const isParent = item.children;
            return (
              <div key={item.label}>
                <button
                  onClick={() => {
                    if (isParent) {
                      setOpenMenu(openMenu === item.label ? null : item.label);
                    } else {
                      if (item.label === "Client Estimates") {
                        handleNavigation(item.path, { fromSidebar: true });
                      } else {
                        handleNavigation(item.path);
                      }
                    }
                  }}
                  className="nav-item w-full flex justify-between"
                >
                  <span className="flex items-center gap-2">
                    <Icon name={item.icon} size={20} />
                    {item.label}
                  </span>

                  {isParent && (
                    <Icon
                      name={openMenu === item.label ? "ChevronUp" : "ChevronDown"}
                      size={16}
                    />
                  )}
                </button>

                {/* Expand children */}
                {isParent && openMenu === item.label && (
                  <div className="ml-6 mt-1 space-y-1">
                    {item.children.map((child) => (
                      <button
                        key={child.path}
                        onClick={() => handleNavigation(child.path)}
                        className="nav-item text-sm w-full text-left"
                      >
                        {child.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </nav>
      </aside>
      <aside className={`sidebar hidden lg:flex flex-col h-screen ${isCollapsed ? 'collapsed' : ''}`}>

        {/* Header */}
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <img src={fpc_logo} />
            {/* <Icon name="Factory" size={24} color="var(--color-primary-foreground)" /> */}
          </div>
          {!isCollapsed && <span className="sidebar-logo-text">Budget Estimator</span>}
        </div>

        {/* Navigation (middle grows) */}
        {/* <nav className="sidebar-nav flex-1"> */}
        <nav className="sidebar-nav flex-1 overflow-y-auto min-h-0 hover:overflow-y-auto">
          {filteredNavItems?.map((item) => {
            const isParent = item.children;
            const active = isActive(item.path);
            return (
              <div
                key={item.label}
                className="relative group"
                onMouseEnter={() => isCollapsed && setOpenMenu(item.label)}
                onMouseLeave={() => isCollapsed && setOpenMenu(null)}
              >
                {/* Parent Button */}
                <button
                  onClick={() => {
                    if (isParent && !isCollapsed) {
                      setOpenMenu(openMenu === item.label ? null : item.label);
                    } else if (item.path) {
                      handleNavigation(item.path);
                    }
                  }}
                  // className="nav-item w-full"
                  // className={`nav-item w-full transition-all duration-200 ${active ? " text-primary-foreground" : "hover:bg-muted"
                  className={`nav-item w-full transition-all duration-200 ${active ? " text-primary-foreground bg-muted " : "hover:bg-muted"
                    }`}
                >
                  <span className="nav-item-icon">
                    <Icon name={item.icon} size={20} />
                  </span>

                  {!isCollapsed && (
                    <span className="nav-item-label flex justify-between w-full">
                      {item.label}
                      {isParent && (
                        <Icon
                          name={openMenu === item.label ? "ChevronUp" : "ChevronDown"}
                          size={16}
                        />
                      )}
                    </span>
                  )}
                </button>

                {/* ✅ Expanded Mode (Accordion) */}
                {!isCollapsed && isParent && openMenu === item.label && (
                  <div className="ml-8 mt-1 space-y-1">
                    {item.children.map((child) => (
                      <button
                        key={child.path}
                        onClick={() => handleNavigation(child.path)}
                        className="nav-item text-sm w-full"
                      >
                        {child.label}
                      </button>
                    ))}
                  </div>
                )}

                {/* ✅ Collapsed Mode (Hover Flyout) */}
                {isCollapsed && isParent && openMenu === item.label && (
                  <div className="absolute left-full top-0 ml-0 w-52 bg-card border border-border rounded-lg shadow-lg p-2 z-30">
                    {item.children.map((child) => (
                      <button
                        key={child.path}
                        onClick={() => handleNavigation(child.path)}
                        className="block w-full text-left px-3 py-2 rounded-md hover:bg-muted text-sm"
                      >
                        {child.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        {/* Bottom Section */}
        <div className="border-t border-border p-3 space-y-2">
          {/* Collapse */}
          <button
            className="nav-item w-full"
            onClick={(e) => {
              e.stopPropagation();
              onCollapse && onCollapse(!isCollapsed);
            }}
            title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            <span
              className="nav-item-icon"
            >
              <Icon name={isCollapsed ? 'ChevronRight' : 'ChevronLeft'} size={20} />
            </span>
            {!isCollapsed && <span className="nav-item-label">Collapse</span>}
          </button>

          <div className="relative" ref={dropdownRef}>
            <button
              className="nav-item w-full flex items-center px-2 py-2"
              onClick={() => setIsProfileOpen((prev) => !prev)}
            >
              {userDetails?.fullName && (
                <span className="flex-shrink-0">
                  <Avatar id={userDetails.fullName} />
                </span>
              )}

              {!isCollapsed && (
                <div className="flex flex-col ml-2 text-left">
                  <div className="font-semibold">{userDetails?.fullName}</div>
                  <div className="text-sm text-gray-500">
                    {getRole(userDetails?.role)}
                  </div>
                </div>
              )}
            </button>

            {isProfileOpen && (
              <div className="absolute bottom-full mb-2 left-0 w-48 bg-white border border-gray-200 rounded-lg shadow-lg py-1 z-30">
                <button
                  onClick={() => {
                    navigate("/app/profile-settings");
                    setIsProfileOpen(false);
                  }}
                  className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 transition-colors"
                >
                  Profile Settings
                </button>

                {/* Divider */}
                <div className="h-px bg-gray-200 my-1" />

                <button
                  onClick={handleLogout}
                  className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                >
                  Logout
                </button>
              </div>
            )}
          </div>

        </div>

      </aside>

    </>
  );
};

export default memo(Sidebar);